var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-370.000000, -790.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.110000, 774.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ACT-icons-52",
    transform: "translate(351.890000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2570043,0.602995682 C9.78525556,0.134968476 9.02433918,0.134968476 8.5525904,0.602995682 L5.43000001,3.72558608 L2.30740961,0.602995682 C1.8367487,0.132334773 1.07365659,0.132334773 0.602995682,0.602995682 C0.132334773,1.07365659 0.132334773,1.8367487 0.602995682,2.30740961 L3.72558608,5.43 L0.602995682,8.55259039 C0.132334773,9.0232513 0.132334773,9.78634341 0.602995682,10.2570043 C1.07365659,10.7276652 1.8367487,10.7276652 2.30740961,10.2570043 L5.43000001,7.13441392 L8.5525904,10.2570043 C9.02325132,10.7276652 9.78634341,10.7276652 10.2570043,10.2570043 C10.7276652,9.7863434 10.7276652,9.02325131 10.2570043,8.55259039 L7.13441393,5.43 L10.2570043,2.30740961 C10.7250315,1.83566083 10.7250315,1.07474445 10.2570043,0.602995682 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9ca1fa33.svg";
export { ForwardRef as ReactComponent };